import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import ConfirmationForm from "@/components/organisms/Pages/ConfirmationForm";

const ConfirmUser = (
  {
    requires_password: requiresPassword,
    confirmation_token: confirmationToken,
    all_time_zones: allTimeZones,
    selected_time_zone: selectedTimeZone 
  }: any) => {
    const [toastMessage, setToastMessage] = useState<{success: boolean, message: string} | null>(null);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  
    const getCsrfToken = () => {
      const tokenMeta = document.querySelector('meta[name="csrf-token"]');
      return tokenMeta ? tokenMeta.getAttribute('content') || '' : '';
    };

    const onSubmit = async (data: any) => {
      setIsSubmitting(true);
      console.log(data);
      try {
        const response = await fetch('/users/confirmation', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': getCsrfToken(),
          },
          body: JSON.stringify({
            confirmation_token: confirmationToken,
            user: {
              password: data.password,
              password_confirmation: data.passwordConfirmation,
              time_zone: data.timeZone },
          }),
        });
        
        const responseData = await response.json();

        if (response.ok) {
          if (responseData.redirect_url) {
            window.location.href = responseData.redirect_url;
          } else {
            setToastMessage({ success: true, message: "Your account has been confirmed successfully! Redirecting..." });
            setTimeout(() => {
              window.location.href = "/";
            }, 1500);
          }
        } else {
          setToastMessage({ success: false, message: `Error: ${responseData.message}`});
        }
      } catch (error) {
        setToastMessage({ success: false, message: `Error: ${error}` });
      } finally {
        setIsSubmitting(false);
      }
    }

    useEffect(() => {
      if (toastMessage) {
        if (toastMessage.success) {
          toast.success(toastMessage.message);
        } else {
          toast.error(toastMessage.message);
        }
      }
    }, [toastMessage]);

    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="bg-white shadow-lg h-auto rounded-lg w-2/6 p-10">
          <div className="flex justify-center mb-16">
            <img
              src="/images/logo_mark.png"
              alt="logo"
              className="w-48"
            />
          </div>

          <h2 className="flex justify-center text-3xl font-bold text-gray-800 mb-2">
            Confirm Your Account
          </h2>

          <ConfirmationForm
            requiresPassword={requiresPassword}
            allTimeZones={allTimeZones}
            selectedTimeZone={selectedTimeZone}
            onSubmit={onSubmit}
            isSubmitting={isSubmitting}
          />
        </div>
      </div>
    );
  };

export default ConfirmUser;
